import { createSlice } from '@reduxjs/toolkit';
import { LABELGENAPI } from '../../../API';
import { logFrontendActivity } from '../../General/activityLogger';

export const lineitemsettingslice = createSlice({
    name: 'lineitemsettings',
    initialState: {
        orderLineItemData: {
            data: [],
            loading: false,
            meta: {
                page: 1,
                per_page: 10,
            },
            notification: { show: false, messageContent: "", messageType: "success" }
        },
        NewrOrderLineItemData: {
            data: [],
            loading: false,
            newMeta: {
                page: 1,
                per_page: 10,
            },
            notification: { show: false, messageContent: "", messageType: "success" }
        },
        kitOrderLineItemData: {
            data: [],
            loading: false,
            kitMeta: {
                page: 1,
                per_page: 10,
            },
            notification: { show: false, messageContent: "", messageType: "success" }
        },
        importproducts: {
            loading: false,
            hasErrors: false,
            notification: { show: false, messageContent: "", messageType: "success" }
        },
        lineitemsnotify: {
            loading: false,
            hasErrors: false,
            notification: { show: false, messageContent: "", messageType: "success" }
        },
        updatelineitems: {
            loading: false,
            hasErrors: false,
            notification: { show: false, messageContent: "", messageType: "success" }
        },
        skuINfo: {
            data: [],
            loading: false,
            notification: { show: false, messageContent: "", messageType: "success" }
        },
    },
    reducers: {
        getSkuInfo: (state) => {
            return {
                ...state,
                skuINfo: {
                    ...state.skuINfo,
                    data: [],
                    loading: true,
                    hasErrors: false
                }
            }
        },
        getSkuInfoSuccess: (state, action) => {
            return {
                ...state,
                skuINfo: {
                    ...state.skuINfo,
                    data: action && action.payload && action.payload.data,
                    loading: false,
                    notification: { show: true, messageContent: action && action.payload && action.payload.data && action.payload.data.message && [action.payload.data.message], messageType: "success" }
                }
            }
        },
        getSkuInfoFailure: (state, action) => {
            return {
                ...state,
                skuINfo: {
                    ...state.skuINfo,
                    data:[],
                    loading: false,
                    notification: { show: true, messageContent: action && action.payload && action.payload.data && action.payload.data.message && [action.payload.data.message], messageType: "error" }
                }
            }
        },
        getLineitemData: (state) => {
            return {
                ...state,
                orderLineItemData: {
                    ...state.orderLineItemData,
                    loading: true,
                    hasErrors: false
                }
            }
        },
        getLineitemDataSuccess: (state, action) => {
            return {
                ...state,
                orderLineItemData: {
                    ...state.orderLineItemData,
                    data: action && action.payload && action.payload.data && action.payload.data.data,
                    meta: action && action.payload && action.payload.data && action.payload.data.meta,
                    loading: false,
                    notification: { show: true, messageContent: action && action.payload && action.payload.data && action.payload.data.message && [action.payload.data.message], messageType: "success" }
                }
            }
        },
        getLineitemDataFailure: (state, action) => {
            return {
                ...state,
                orderLineItemData: {
                    ...state.orderLineItemData,
                    loading: false,
                    notification: { show: true, messageContent: action && action.payload && action.payload.data && action.payload.data.message && [action.payload.data.message], messageType: "error" }
                }
            }
        },
        getNewLineitemData: (state) => {
            return {
                ...state,
                NewrOrderLineItemData: {
                    ...state.NewrOrderLineItemData,
                    loading: true,
                    hasErrors: false
                }
            }
        },
        getNewLineitemDataSuccess: (state, action) => {
            return {
                ...state,
                NewrOrderLineItemData: {
                    ...state.NewrOrderLineItemData,
                    data: action && action.payload && action.payload.data && action.payload.data.data,
                    newMeta: action && action.payload && action.payload.data && action.payload.data.meta,
                    loading: false,
                    notification: { show: true, messageContent: action && action.payload && action.payload.data && action.payload.data.message && [action.payload.data.message], messageType: "success" }
                }
            }
        },
        getNewLineitemDataFailure: (state, action) => {
            return {
                ...state,
                NewrOrderLineItemData: {
                    ...state.NewrOrderLineItemData,
                    loading: false,
                    notification: { show: true, messageContent: action && action.payload && action.payload.data && action.payload.data.message && [action.payload.data.message], messageType: "error" }
                }
            }
        },
        getKitLineitemData: (state) => {
            return {
                ...state,
                kitOrderLineItemData: {
                    ...state.kitOrderLineItemData,
                    loading: true,
                    hasErrors: false
                }
            }
        },
        getKitLineitemDataSuccess: (state, action) => {
            return {
                ...state,
                kitOrderLineItemData: {
                    ...state.kitOrderLineItemData,
                    data: action && action.payload && action.payload.data && action.payload.data.data,
                    kitMeta: action && action.payload && action.payload.data && action.payload.data.meta,
                    loading: false,
                    notification: { show: true, messageContent: action && action.payload && action.payload.data && action.payload.data.message && [action.payload.data.message], messageType: "success" }
                }
            }
        },
        getKitLineitemDataFailure: (state, action) => {
            return {
                ...state,
                kitOrderLineItemData: {
                    ...state.kitOrderLineItemData,
                    loading: false,
                    notification: { show: true, messageContent: action && action.payload && action.payload.data && action.payload.data.message && [action.payload.data.message], messageType: "error" }
                }
            }
        },
        postImportProducts: (state) => {
            return {
                ...state,
                importproducts: {
                    ...state.importproducts,
                    loading: true,
                    hasErrors: false,
                }

            }
        },
        postImportProductsSuccess: (state, action) => {
            return {
                ...state,
                importproducts: {
                    ...state.importproducts,
                    loading: false,
                    hasErrors: false,
                    notification: { show: true, messageContent: action && action.payload && action.payload.data && action.payload.data.data && [action.payload.data.data.message], messageType: "success" }
                }

            }

        },
        postImportProductsFailure: (state, action) => {
            return {
                ...state,
                importproducts: {
                    ...state.importproducts,
                    loading: false,
                    hasErrors: true,
                    notification: { show: true, messageContent: action && action.payload && action.payload.data && action.payload.data.data && [action.payload.data.data.message], messageType: "error" }
                }

            }

        },
        lineitemsNotification: (state) => {
            return {
                ...state,
                lineitemsnotify: {
                    ...state.lineitemsnotify,
                    loading: true,
                    hasErrors: false,
                }

            }
        },
        lineitemsNotificationSuccess: (state, action) => {
            return {
                ...state,
                lineitemsnotify: {
                    ...state.lineitemsnotify,
                    loading: false,
                    hasErrors: false,
                    notification: { show: true, messageContent: action && action.payload && action.payload.data && action.payload.data.data && [action.payload.data.data.message], messageType: "success" }
                }

            }
        },
        lineitemsNotificationFailure: (state, action) => {
            return {
                ...state,
                lineitemsnotify: {
                    ...state.lineitemsnotify,
                    loading: false,
                    hasErrors: true,
                    notification: { show: true, messageContent: action && action.payload && action.payload.data && action.payload.data.data && [action.payload.data.data.message], messageType: "error" }
                }
            }
        },
        updateLineitemData: (state) => {
            return {
                ...state,
                updatelineitems: {
                    ...state.updatelineitems,
                    loading: true,
                    hasErrors: false
                }
            }
        },
        updateLineitemDataSuccess: (state, action) => {
            return {
                ...state,
                updatelineitems: {
                    ...state.updatelineitems,
                    data: action && action.payload && action.payload.data && action.payload.data.data,
                    meta: action && action.payload && action.payload.data && action.payload.data.meta,
                    loading: false,
                    notification: { show: true, messageContent: action && action.payload && action.payload.data && action.payload.data.message && [action.payload.data.message], messageType: "success" }
                }
            }
        },
        updateLineitemDataFailure: (state, action) => {
            return {
                ...state,
                updatelineitems: {
                    ...state.updatelineitems,
                    loading: false,
                    notification: { show: true, messageContent: action && action.payload && action.payload.data && action.payload.data.message && [action.payload.data.message], messageType: "error" }
                }
            }
        },
        resetLineItemSettings: (state) => {
            return {
                ...state,
                importproducts: {
                    ...state.importproducts,
                    loading: false,
                    hasError: false,
                    notification: { show: false, messageContent: "", messageType: "success" }
                },
                lineitemsnotify: {
                    ...state.lineitemsnotify,
                    loading: false,
                    hasErrors: false,
                    notification: { show: false, messageContent: "", messageType: "success" }
                },
                updatelineitems: {
                    ...state.updatelineitems,
                    loading: false,
                    hasErrors: false,
                    notification: { show: false, messageContent: "", messageType: "success" }
                },
                // skuINfo:{
                //      ...state.skuINfo,
                //     data:[],
                //     loading: false,
                //     hasErrors: false,
                //     notification: { show: false, messageContent: "", messageType: "success" }
                // }
            }
        }
    }
})
export const { getLineitemData, getLineitemDataSuccess, getLineitemDataFailure } = lineitemsettingslice.actions;


export const fetchLineItemsData = (meta) => {
    const qs = Object.keys(meta)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(meta[key])}`)
        .join('&');

    return (dispatch) => {
        dispatch(getLineitemData());
        try {
            LABELGENAPI
                .get('/settings/lineitems-settings?' + qs)
                .then(function (response) {
                    dispatch(getLineitemDataSuccess(response));
                })
                .catch(function (error) {
                    dispatch(getLineitemDataFailure(error.response));
                });
        } catch (error) {
            dispatch(getLineitemDataFailure());
        }
    };
};

export const { getNewLineitemData, getNewLineitemDataSuccess, getNewLineitemDataFailure } = lineitemsettingslice.actions;

export const fetchNewLineItemsData = (meta) => {
    const qs = Object.keys(meta)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(meta[key])}`)
        .join('&');

    return (dispatch) => {
        dispatch(getNewLineitemData());
        try {
            LABELGENAPI
                .get('/settings/newlineitems-settings?' + qs)
                .then(function (response) {
                    dispatch(getNewLineitemDataSuccess(response));
                })
                .catch(function (error) {
                    dispatch(getNewLineitemDataFailure(error.response));
                });
        } catch (error) {
            dispatch(getNewLineitemDataFailure());
        }
    };
};

export const { getKitLineitemData, getKitLineitemDataSuccess, getKitLineitemDataFailure } = lineitemsettingslice.actions;


export const fetchKitLineItemsData = (meta) => {
    const qs = Object.keys(meta)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(meta[key])}`)
        .join('&');

    return (dispatch) => {
        dispatch(getKitLineitemData());
        try {
            LABELGENAPI
                .get('/settings/kitlineitems-settings?' + qs)
                .then(function (response) {
                    dispatch(getKitLineitemDataSuccess(response));
                })
                .catch(function (error) {
                    dispatch(getKitLineitemDataFailure(error.response));
                });
        } catch (error) {
            dispatch(getKitLineitemDataFailure());
        }
    };
};

export const { postImportProducts, postImportProductsSuccess, postImportProductsFailure } = lineitemsettingslice.actions;

export const importProducts = data => dispatch => {
    dispatch(postImportProducts());
    try {
        LABELGENAPI.post('/settings/import-products', data)
            .then(function (response) {
                dispatch(postImportProductsSuccess(response));
                dispatch(fetchNewLineItemsData({}));
                dispatch(fetchKitLineItemsData({}));
            }).catch(function (error) {
                dispatch(postImportProductsFailure(error.response));
            })
    }
    catch (error) {
        dispatch(postImportProductsFailure(error.response));
    }
}

export const { lineitemsNotification, lineitemsNotificationSuccess, lineitemsNotificationFailure } = lineitemsettingslice.actions;

export const storeNewProduct = (userid, data) => dispatch => {
    dispatch(lineitemsNotification());
    const logRef = crypto.randomUUID();
    try {
        LABELGENAPI.post('/settings/lineitems-settings', data, { 
        headers: { 
            'x-log-ref': logRef
              } 
        })
        .then(function (response) {
            dispatch(lineitemsNotificationSuccess(response));
            dispatch(fetchNewLineItemsData({}));
            dispatch(fetchKitLineItemsData({}));
            logFrontendActivity({
                group: 'SETTINGS',
                subgroup: 'LINEITEM_SETTINGS',
                action: 'SUCCESS',
                request_data: data,
                response_data: response.data,
                log_ref: logRef,
                userid: userid
            }).then((ref) => {
                if (ref) {
                    console.log('Activity log recorded with log_ref:', ref);
                }else{
                    console.log('Activity log failed:', ref);
                }
            }); 
        }).catch(function (error) {
            dispatch(lineitemsNotificationFailure(error.response));
            dispatch(fetchNewLineItemsData({}));
            dispatch(fetchKitLineItemsData({}));
            logFrontendActivity({
              group: 'SETTINGS',
              subgroup: 'LINEITEM_SETTINGS',
              action: 'FAILURE',
              request_data: data,
              response_data: error.response?.data || {},
              log_ref: logRef,
              userid: userid
          }).then((ref) => {
              if (ref) {
                  console.log('Activity log recorded with log_ref:', ref);
              }
          }); 
        })
    }
    catch (error) {
        dispatch(lineitemsNotificationFailure(error.response));
        dispatch(fetchNewLineItemsData({}));
        dispatch(fetchKitLineItemsData({}));
        logFrontendActivity({
              group: 'SETTINGS',
              subgroup: 'LINEITEM_SETTINGS',
              action: 'FAILURE',
              request_data: data,
              response_data: error.response?.data || {},
              log_ref: logRef,
              userid: userid
          }).then((ref) => {
              if (ref) {
                  console.log('Activity log recorded with log_ref:', ref);
              }
          }); 
    }
}

export const updateLineItems = (userid,id, data) => dispatch => {
    console.log(id)
    console.log(data)
    dispatch(lineitemsNotification());
    const logRef = crypto.randomUUID();
    try {
        LABELGENAPI.patch('/settings/lineitems-settings/' + id, data)
            .then(function (response) {
                dispatch(lineitemsNotificationSuccess(response));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'LINEITEM_SETTINGS',
                    action: 'SUCCESS',
                    request_data: data,
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                });
                if (data.type.includes("New")) {
                    dispatch(fetchNewLineItemsData({}));
                    dispatch(fetchKitLineItemsData({}));
                } else {
                    dispatch(fetchLineItemsData({}));
                    dispatch(fetchKitLineItemsData({}));
                }
            }).catch(function (error) {
                dispatch(lineitemsNotificationFailure(error.response));
                dispatch(fetchNewLineItemsData({}));
                dispatch(fetchKitLineItemsData({}));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'LINEITEM_SETTINGS',
                    action: 'FAILURE',
                    request_data: data,
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                });
            })
    }
    catch (error) {
        dispatch(lineitemsNotificationFailure(error.response));
        dispatch(fetchNewLineItemsData({}));
        dispatch(fetchKitLineItemsData({}));
        logFrontendActivity({
            group: 'SETTINGS',
            subgroup: 'LINEITEM_SETTINGS',
            action: 'FAILURE',
            request_data: data,
            response_data: error.response?.data || {},
            log_ref: logRef,
            userid: userid
        }).then((ref) => {
            if (ref) {
                console.log('Activity log recorded with log_ref:', ref);
            }
        });
    }
}

export const destoryLineitems = (userid,id,value) => dispatch => {
    dispatch(lineitemsNotification());
    const logRef = crypto.randomUUID();
    try {
        LABELGENAPI
            .delete("/settings/lineitems-settings/" + id + "/" + value, { 
            headers: { 
                'x-log-ref': logRef
                 } 
            })
            .then(function (response) {
                dispatch(lineitemsNotificationSuccess(response));
                dispatch(fetchNewLineItemsData({}));
                dispatch(fetchKitLineItemsData({}));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'LINEITEM_SETTINGS',
                    action: 'SUCCESS',
                    request_data: JSON.stringify(id),
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                });
            })
            .catch(function (error) {
                dispatch(lineitemsNotificationFailure(error.response));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'LINEITEM_SETTINGS',
                    action: 'FAILURE',
                    request_data: JSON.stringify(id),
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                });
            });
    } catch (error) {
        dispatch(lineitemsNotificationFailure(error));
        logFrontendActivity({
                group: 'SETTINGS',
                subgroup: 'LINEITEM_SETTINGS',
                action: 'FAILURE',
                request_data: JSON.stringify(id),
                response_data: error.response?.data || {},
                log_ref: logRef,
                userid: userid
            }).then((ref) => {
                if (ref) {
                    console.log('Activity log recorded with log_ref:', ref);
                }
            });
    }
};

export const { updateLineitemData, updateLineitemDataSuccess, updateLineitemDataFailure } = lineitemsettingslice.actions;

export const updateLineitemDatas = (data) => {
    return (dispatch) => {
        dispatch(updateLineitemData());
        try {
            LABELGENAPI.post('/upload-lineitems-s3', data)
                .then(function (response) {
                    dispatch(updateLineitemDataSuccess(response));
                })
                .catch(function (error) {
                    dispatch(updateLineitemDataFailure(error.response));
                });
        } catch (error) {
            dispatch(updateLineitemDataFailure());
        }
    };
};

export const { getSkuInfo, getSkuInfoSuccess, getSkuInfoFailure } = lineitemsettingslice.actions;


export const fetchSkuINfo = (data,report) => {
    return (dispatch) => {
        dispatch(getSkuInfo());
        try {
            LABELGENAPI
                .get('/settings/newlineitems-settings/fetch-sku?report='+report+'&sku=' + data)
                .then(function (response) {
                    dispatch(getSkuInfoSuccess(response));
                })
                .catch(function (error) {
                    dispatch(getSkuInfoFailure(error.response));
                });
        } catch (error) {
            dispatch(getSkuInfoFailure());
        }
    };
};

export const patchOrderLineItems = (data) => dispatch => {
    dispatch(updateLineitemData()); // Start loading
    try {
        LABELGENAPI.post('/update-order-lineitems', data)
            .then(function (response) {
                dispatch(updateLineitemDataSuccess(response));
                // Optional: trigger a refresh of the order data if needed
            })
            .catch(function (error) {
                dispatch(updateLineitemDataFailure(error.response));
            });
    } catch (error) {
        dispatch(updateLineitemDataFailure());
    }
};

export const { resetLineItemSettings } = lineitemsettingslice.actions;

export const resetLineItemSettingsState = data => dispatch => {
    dispatch(resetLineItemSettings());
}

export default lineitemsettingslice.reducer;
